import { createReducer } from '../utils/reducers';
import { OPEN_MODAL, CLOSE_MODAL, SET_FORM } from '../actions';
import indexOf from 'lodash/indexOf';
import { VALID_FORMS } from '../constants/forms';
import { LOGOUT_USER_SUCCESS } from '../actions/user';

const INITIAL_STATE = {
    isOpen: false,
    assetID: -1,
    form: '',
    isTriggerExternal: false,
    url: '',
};

export default createReducer(INITIAL_STATE, {
    [OPEN_MODAL]: (state, action) => {
        return {
            ...state,
            isOpen: true,
            assetID: action.assetID,
        };
    },
    [CLOSE_MODAL]: () => {
        return INITIAL_STATE;
    },
    [SET_FORM]: (state, action) => {
        if (isInvalidForm(action.name, VALID_FORMS)) {
            return state;
        }

        return {
            ...state,
            form: action.name,
            isTriggerExternal: action.isTriggerExternal,
            url: action.url,
            title: action.title,
            endDate: action.endDate,
        };
    },
    [LOGOUT_USER_SUCCESS]: () => {
        return INITIAL_STATE;
    },
});

const isInvalidForm = (form, validForms) => -1 === indexOf(VALID_FORMS, form);



// WEBPACK FOOTER //
// ./src/reducers/modal.js